"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var reducers_1 = __importDefault(require("./reducers"));
var redux_devtools_extension_1 = require("redux-devtools-extension");
var Store = redux_1.createStore(reducers_1.default, 
/*preloadedState,*/
redux_devtools_extension_1.devToolsEnhancer({}));
exports.default = Store;
//# sourceMappingURL=Store.js.map